module.exports = __webpack_public_path__ + "images/marketing/seattle-crew-new-office.png";